import { QuestionSchema, UserSchema } from './schemas';

interface ModelProps {
  [key: string]: any;
}

export function ModelFactory<T>(
  definition: ModelProps
): (values?: ModelProps) => T {
  return function Model(values: ModelProps = {}): T {
    const inst: ModelProps = {};
    // Exclude any value not in definition
    Object.keys(definition).forEach((key) => {
      // Prioritize given value or default to definition
      inst[key] = values[key] || definition[key];
    });
    return inst as unknown as T;
  };
}

export const UserModel = ModelFactory<UserSchema>({
  email: '',
  firstName: '',
  fullName: '',
  id: '',
  isMtInternalUser: false,
  isManager: false,
  lastName: '',
  linkedin: '',
  marketoId: '',
  member: '',
  phoneNumber: '',
  photo: '',
  subscribedToMarketing: false,
  username: '',
});

export const QuestionModel = ModelFactory<QuestionSchema>({
  canCreateAudios: true,
  canCreateDocuments: false,
  canCreateImages: false,
  canCreateTexts: true,
  canCreateVideos: true,
  id: '',
  organizationId: '',
  question: '',
  referenceCategory: {},
  referenceCategoryId: '',
});
